export default ['iamaverybadword', 'iamalsoaverybadword']